// src/components/teacher/TeacherDashboard.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getReferralStudents } from '../../services/api';
import Alert from '../common/Alert';
// import Navbar from '../common/Navbar';
import './ReferralDashboard.css';

const TeacherDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [referralCode, setReferralCode] = useState('');
  const [teacher, setTeacher] = useState(null);
  const [students, setStudents] = useState([]);
  const [totalReferrals, setTotalReferrals] = useState(0);
  const [alert, setAlert] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('referralCode');
    
    if (code) {
      setReferralCode(code);
      fetchReferralData(code);
    }
  }, [location.search]);

  const fetchReferralData = async (code) => {
    setIsLoading(true);
    try {
      const response = await getReferralStudents(code);
      setTeacher(response.data.teacher);
      setStudents(response.data.students);
      setTotalReferrals(response.data.totalReferrals);
    } catch (error) {
      setAlert({
        type: 'error',
        message: error.response?.data?.message || 'Failed to fetch data'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!referralCode.trim()) {
      setAlert({
        type: 'error',
        message: 'Please enter a referral code'
      });
      return;
    }
    navigate(`?referralCode=${referralCode}`);
    fetchReferralData(referralCode);
  };

  return (
    <div className="teacher-dashboard-wrapper">
      {/* <Navbar /> */}
      
      <div className="teacher-dashboard-container">
        <div className="referral-code-form">
          <img 
            src="/assets/BigLogo.png" 
            alt="Educatory Logo" 
            className="logo"
          />

          {alert && (
            <Alert 
              message={alert.message} 
              type={alert.type} 
              onClose={() => setAlert(null)} 
            />
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Enter Your Referral Code</label>
              <div className="input-group">
                <input
                  type="text"
                  value={referralCode}
                  onChange={(e) => setReferralCode(e.target.value)}
                  placeholder="e.g., TEACH123"
                  required
                />
                <button type="submit" disabled={isLoading}>
                  {isLoading ? 'Loading...' : 'Fetch Data'}
                </button>
              </div>
            </div>
          </form>
        </div>

        {teacher && (
          <div className="teacher-info-card">
            <h3>Your Information</h3>
            <div className="info-grid">
              <div>
                <span className="label">Name:</span>
                <span>{teacher.name}</span>
              </div>
              <div>
                <span className="label">Role:</span>
                <span>{teacher.type}</span>
              </div>
              {teacher?.institution_name?.length && (
              <div>
                <span className="label">Institution:</span>
                <span>{teacher.institution_name}</span>
              </div>
            )}
              <div>
                <span className="label">Referral Code:</span>
                <span className="highlight">{teacher.referral_code}</span>
              </div>
            </div>
          </div>
        )}

        {totalReferrals > 0 && (
          <div className="stats-cards">
            <div className="stat-card">
              <h3>Total Referrals</h3>
              <p className="stat-value">{totalReferrals}</p>
            </div>
          </div>
        )}

        {students.length > 0 && (
          <div className="students-table-container">
            <h3>Students Referred by You</h3>
            <div className="table-responsive">
              <table className="students-table">
                <thead>
                  <tr>
                    <th>Enrollment ID</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Course</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student) => (
                    <tr key={student.enrollment_id}>
                      <td>{student.enrollment_id}</td>
                      <td>{student.first_name}</td>
                      <td>{student.last_name}</td>
                      <td>{student.course_name}</td>
                      <td>
                        <span className={`status-badge ${student.enrollment_status}`}>
                          {student.enrollment_status.replace('_', ' ')}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {students.length === 0 && teacher && !isLoading && (
          <div className="empty-state">
            <p>No students have registered using your referral code yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherDashboard;